import React from 'react';
import { Typography, Paper } from '@mui/material';
import Layout from '../components/layout/Layout';
import TestingConsole from '../components/testing/TestingConsole';

const Testing = () => {
    return (
        <Layout>
            <Typography variant="h4" sx={{ mb: 3 }}>
                Testing Console
            </Typography>
            <Paper sx={{ p: 2 }}>
                <TestingConsole />
            </Paper>
        </Layout>
    );
};

export default Testing;